import React from 'react';
import { titleize, humanize } from 'underscore.string';
import { Link } from 'react-router-dom';
import { t } from 'i18next';
import Badge from '../../v2/Badge';

const emailFormatter = (cell, rowItem) => {
  return (
    <Link to={`users/${rowItem._id}`} key={rowItem._id} target="_blank">
      <span>{cell}</span>
    </Link>
  );
};

const statusFormatter = (cell) => {
  const isActive = !!cell;
  const active = cell ? t('ACTIVE') : t('DEACTIVATED');

  let color;
  if (isActive) {
    color = 'brand';
  } else {
    color = 'red';
  }

  return <Badge color={color} text={titleize(humanize(active))} />;
};

const columns = [
  {
    dataField: 'first_name',
    text: 'First Name',
    sort: true,
    localizationSlug: 'FIRST_NAME',
  },
  {
    dataField: 'last_name',
    text: 'Last Name',
    sort: true,
    localizationSlug: 'LAST_NAME',
  },
  {
    dataField: 'email',
    type: 'credentials',
    text: 'Email',
    sort: true,
    headerStyle: {
      width: '20%',
    },
    formatter: emailFormatter,
    localizationSlug: 'EMAIL',
  },
  {
    dataField: 'roles',
    text: 'Roles',
    type: 'roles',
    localizationSlug: 'ROLES',
  },
  {
    dataField: 'last_login_session',
    text: 'Last Seen',
    type: 'datetime',
    sort: true,
    localizationSlug: 'LAST_SEEN',
  },
  {
    dataField: 'active',
    text: 'Status',
    sort: true,
    formatter: statusFormatter,
    localizationSlug: 'STATUS',
  },
];

export default {
  columns,
};
